<template>
                <div class="content">
                    <h1>Account</h1>
                     <div class="row name-input-group ">
                         <div class = 'col-md-6'>
                            <label class=" pure-material-textfield-outlined ">
                                <input class="form-control"
                                type="text" 
                                @blur="checkFirstName"
                                v-model="firstName"
                                placeholder=" "
                                >
                                <span>First Name</span>
                                <p class="error-message">{{firstname_message || "&nbsp;"}}</p>
                            </label>
                         </div>
                        <div class ='col-md-6'>
                            <label class=" pure-material-textfield-outlined ">
                                <input 
                                type="text" 
                                class="form-control"
                                @blur="checkLastName"
                                v-model="lastName"
                                placeholder=" "
                                >
                                <span>Last Name</span>
                                <p class="error-message">{{lastname_message || "&nbsp;"}}</p>
                            </label>
                        </div>
                     </div>
                     <div>
                        <label class=" pure-material-textfield-outlined ">
                                <input class="form-control"
                                type="email"
                                v-model="email"
                                @blur="checkUserNameInput"
                                @keyup="checkUserEmail"
                                placeholder=" "
                                >
                                <span>Email</span>
                                <p class="error-message">{{email_message || "&nbsp;"}}</p>
                        </label>
                     </div>
                     <div>
                        <label class=" pure-material-textfield-outlined ">
                                <input class="form-control"
                                type="email"
                                @keyup="checkConfirmEmail"
                                @blur="checkUserNameInput"
                                v-model="confirmEmail"
                                placeholder=" "
                                >
                                <span>Confirm Email</span>
                                <p class="error-message">{{confirm_email_message || "&nbsp;"}}</p>
                        </label>
                     </div>
                     <div class="row" style="">
                         <div class="col-11">
                            <label class=" pure-material-textfield-outlined ">
                                <input @ class="form-control"
                                :type="hidePassword ? 'password' : 'text'" 
                                @keyup="checkPasswordLength"
                                @blur="checkUserNameInput"
                                v-model="password"
                                placeholder=" "
                                >
                                <span>Password</span>
                                <p class="error-message">{{password_message || "&nbsp;"}}</p>
                            </label> 
                         </div>
                        <div @click="toggleDisplay()" >
                            <v-icon style="width:22px; margin-top:15px" :name="hidePassword ? 'eye-off': 'eye'"></v-icon>
                        </div>
                         
                     </div>
                                            
                </div>  
</template>


<script>
import { mapState, mapActions } from "vuex";

export default {


   computed: {
      firstName: {
        get() {
          return this.$store.getters.userFirstName;
        },
        set(val) {
          this.$store.commit("setUserFirstName", val);
        }
      },

      lastName: {
        get() {
          return this.$store.getters.userLastName;
        },
        set(val) {
          this.$store.commit("setUserLastName", val);
        }
      },

      email: {
        get() {
          return this.$store.getters.userEmail;
        },
        set(val) {
          this.$store.commit("setUserEmail", val);
        }
      },

      password: {
        get() {
          return this.$store.getters.userPassword;
        },
        set(val) {
          this.$store.commit("setUserPassword", val);
        }        
      }



     },
     
    data() {
        return {
            confirmEmail:'',
            // Error Messages
            // sign up error
            firstname_message: "",
            lastname_message: "",
            email_message: "",
            password_message: "",
            confirm_email_message: "",
            hidePassword:true,
        }
    },
    methods: {
        toggleDisplay() {
            this.hidePassword = ! this.hidePassword;
        },

        resetAllErrorMessage() {

          this.firstName_message = "";
          this.lastName_message = "";
          this.email_message = "";
          this.password_message = "";
          this.confirm_email_message= "";
        },

        checkPasswordLength() {
          // get the global constant
          const len = this.$globalConstants.MIN_PASSWORD_LENGTH || 10;
          if (this.password.length < len) {
            this.password_message = `*Password must be at least ${len} characters long`;
          } else {
            this.password_message = '';
          }
        },

        checkUserEmail() {
          if (!this.checkEmailFormat(this.email)) {
            this.email_message = "*Invalid email format";

          } else {
            this.email_message = ''
            };
        },

        checkConfirmEmail() {
           if (this.email !== this.confirmEmail) {
            this.confirm_email_message = "*Email needs to match!";
          } else this.confirm_email_message = ''
        },

        checkFirstName() {
          if (this.firstName.length < 1) {
              this.firstname_message = "*Please provide your first name";
            } else this.firstname_message = "";
        },

        checkLastName() {
          if (this.lastName.length < 1) {
            this.lastname_message = "*Please provide your last name";
          } else this.lastname_message = "";
        },

        checkUserNameInput() {
          this.checkFirstName();
          this.checkLastName();
        },

        validateSignUpForm() {
          
          this.checkUserNameInput();
          this.checkUserEmail();
          this.checkConfirmEmail();
          this.checkPasswordLength();
          const { email_message,confirm_email_message,firstname_message,lastname_message, password_message } = this;
          const payload = { email_message,confirm_email_message,firstname_message,lastname_message, password_message };
          this.$store.dispatch('validateForm', payload);              
        }

    }
    
}
</script>


<style scoped>

*{
  font-family: Jura;
  font-weight: bold !important;
}

.content {
    height: 70vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;   
}
 h1 {
  height: 63px;
  font-family: Jura;
  font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.41px;
  /* margin-top: 5rem; */
  color: #4a4a4a;
}



.icon:hover {
  cursor: pointer;
}

.name-input-group {
    justify-content: space-between;
}


.error-message {
  font-size: 16px;
  color: red;
  /* margin-top: -10px;
  margin-bottom: 10px; */
  margin-left: 2px;
  text-align: left;
}

/* css effects for input */

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  /* margin: 10px auto; */
  display: block;
  padding-top: 6px;

  font-family: var(
    --pure-material-font,
    "Arial, Helvetica, sans-serif",
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  /* border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  /* color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined
      > input
      + span
      .pure-material-textfield-outlined
      > input
      + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.1s;
    }
  }
}

@media screen and (max-width: 1400px) {
  .card {
    width: 50%;
  }
}

@media screen and (max-width: 1100px) {
  .card {
    width: 60%;
  }
}
@media screen and (max-width: 800px) {
  .tab_change {
    /* float: none;
			margin:0; */
    width: 100%;
    font-size: 0.5rem;
    flex-direction: column;
  }
  .card {
    width: 80%;
  }
}

@media screen and (max-width: 600px) {
  .card {
    width: 100%;
  }

  #terms {
    width: 15rem !important;
  }
}

@media screen and (max-width: 450px) {
  .btn-info {
    width: 80%;
  }

  .pure-material-textfield-outlined {
    /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
    width: 80%;
  }
  h2 {
    font-size: 1rem;
    font-weight: bold;
    margin-top: 8%;
  }
  .selector > div {
    padding: 8px 40px;
  }
}


</style>






// WEBPACK FOOTER //
// src/components/form/create-account-form.vue